import { openWhatsApp } from "../../utils/whatsapp";

export default function Navbar({ scrolled, mobileOpen, setMobileOpen }) {
  const links = [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Features", href: "#features" },
    { label: "Results", href: "#outcomes" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <>
      <nav className={`sm-nav${scrolled ? " scrolled" : ""}`}>
        <a href="#hero" className="sm-logo">
          <span className="sm-logo-dot" /> Stock Move
        </a>

        <div className="sm-nav-links">
          {links.map((link) => (
            <a key={link.label} href={link.href} className="sm-nav-link">
              {link.label}
            </a>
          ))}
          <button onClick={() => openWhatsApp()} className="sm-nav-cta">
            Get Free Inventory Audit
          </button>
        </div>

        <button
          className="sm-hamburger"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`sm-mobile-menu${mobileOpen ? " open" : ""}`}>
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="sm-nav-link"
            onClick={() => setMobileOpen(false)}
          >
            {link.label}
          </a>
        ))}
        <a
          href="#cta"
          className="sm-nav-cta"
          onClick={() => setMobileOpen(false)}
        >
          Get Free Inventory Audit
        </a>
      </div>
    </>
  );
}